export const DELETE_ENGRAVING_MUTATION = `
mutation CartMutation($itemId: Int!){
  deleteEngraving(itemId: $itemId) {
      data {
          products {
              additionalVariantInfo
              productId
              productCode
              masterId
              masterProductCode
              url
              imageUrl
              brandId
              brandName
              name
              variant
              subName
              annotation
              package
              maxOrderQty
              canBuy
              stockAvailability
              orderUnit
              showWatchdog
              primaryCategories {
                kind
                category
                subCategory
                type
              }
            	unitPrice {
                amount
                price
                unit
              }
              itemId
              count
              vat
              priceWithVat
              priceSumWithVat
              engraving {
                  value
                  priceWithVat
                  cartServiceItem
                  cartItemId
              }
              isHidden
              action
              freeProduct
              addedByCoupon
              autoInserted
              usedProductInfo {
                  volumeInPercent
                  descriptions
              }
              upselling
              tryItFirstId
              attributes {
                  key
                  value
              }
              priceHistory
              discount
              voucherDiscount {
                voucherCode
                discountedPrice
              }
              isLoyalty
              isMedicinal
          }
          discounts {
            discountType
            isPercentDiscount
            maxDiscount
            moneyValue
            percentValue
          }
          serviceItems {
            giftPackagings {
                productId
                productCode
                itemId
                count
                vat
                priceWithVat
                priceSumWithVat
            }
          }
          pricesSummary {
              vat
              priceItemSummary
              pricePayment
              priceDelivery
              priceProductsSummary
              discountWithoutDelivery
          }
          benefits {
            loyalty {
              loyalties {
                  percentageValue
                  localizedNavigationName
                  discountType
                  loyaltyType
                  value
                  state
                  tags
                  orderPriceActivationThresholdWithVat
                  minimalOrderPriceThresholdWithVat
                  expirationDate
                  validUntil
              }
            }
            vouchers {
              code
              isDeliveryVoucher
              value
            }
          }
      }
      messages
  }
}
`;
